import type { DisplayState, Strings } from "../state.js";
import { Orb } from "./Orb.js";
import { HangUpIcon, ChevronUpIcon } from "./icons.js";
import type { ResolvedOrbPalette } from "../orbPalette.js";

export interface TriggerProps {
  label: string;
  strings: Strings;
  displayState: DisplayState;
  /** True while a call is connecting/connected — shows the in-call layout with a hang-up control. */
  active: boolean;
  /** Idle: start the call + expand. */
  onClick(): void;
  /** In-call: end the call (hang up). */
  onStop(): void;
  /** In-call: expand the panel (orb + chevron). */
  onExpand(): void;
  palette?: ResolvedOrbPalette;
}

export function Trigger({
  label,
  strings,
  displayState,
  active,
  onClick,
  onStop,
  onExpand,
  palette,
}: TriggerProps) {
  // In-call: a folded pill can't be a single <button> (the hang-up control would
  // nest a button in a button), so render three sibling controls: orb → expand,
  // hang-up → end, chevron → expand.
  if (active) {
    return (
      <div class="va-trigger-call" role="group" aria-label={label}>
        <button
          type="button"
          class="va-trigger-orb"
          aria-label={strings.expandAssistant}
          onClick={onExpand}
        >
          <Orb displayState={displayState} palette={palette} />
        </button>
        <button
          type="button"
          class="va-call-button va-trigger-hangup"
          data-active="true"
          aria-label={strings.endCall}
          onClick={onStop}
        >
          <HangUpIcon />
        </button>
        <button
          type="button"
          class="va-trigger-expand"
          aria-label={strings.expandAssistant}
          onClick={onExpand}
        >
          <ChevronUpIcon />
        </button>
      </div>
    );
  }

  return (
    <button type="button" class="va-trigger" aria-label={label} onClick={onClick}>
      <Orb displayState={displayState} palette={palette} />
      <span class="va-trigger-label">{label}</span>
    </button>
  );
}
